import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import { NewPlayerRequest } from '../../../Api/Requests/models'
import { rejectUser } from '../../../Api/Requests/Requests'
import toast from 'react-hot-toast'

interface RejectUserModalProps {
    show: boolean
    onHide: () => void
    request: NewPlayerRequest
    closeBothModals: () => void
    fetchRequests: () => void
}

export const RejectUserModal = ({ show, onHide, closeBothModals, request, fetchRequests}: RejectUserModalProps) => {

    const [reason, setReason] = useState('')

    const handleReject = async () => {
        if (!reason) {
            toast.error('Debes introducir un motivo')
            return
        }

        if (reason.length < 5) {
            toast.error('El motivo debe tener al menos 5 caracteres')
            return
        }

        try {
            await rejectUser({ id: request.id, reason })
            closeBothModals()
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <Modal show={show} onHide={onHide} size='lg' centered keyboard={false} backdrop="static" >
            <div className="border rounded-3 px-4 border-primary rounded-3" >
                <Modal.Header>
                    <Modal.Title>Rechazar creación de usuario<br /> <span className='text-primaryy'>{request.email}</span></Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className='d-flex flex-column gap-2'>
                        <div className='text-center'>
                            <span className='text-primary'>Indica el motivo por el cual rechazas la solicitud</span>
                        </div>
                        <div>
                            <Form.Control as="textarea" placeholder="Ingrese el motivo" style={{ minHeight: '100px' }} value={reason} onChange={(e) => setReason(e.target.value)} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex justify-content-end w-100 gap-2'>
                        <Button variant="secondary" onClick={onHide}>
                            Cerrar
                        </Button>
                        <Button variant="danger" onClick={handleReject}>
                            Rechazar
                        </Button>
                    </div>
                </Modal.Footer>
            </div >
        </Modal >
    )
}
